import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { HostLegacy, LayoutLegacy } from "@silvertours/front-legacy-entities";
import { SearchForm } from "../SearchFormLegacy";
import { StageContentContainer, StageCaption } from "../StageLegacy/Stage.styles";
var setAffiliateConsentStyle = function(customColor) {
    return /*#__PURE__*/ _jsx("style", {
        children: "\n      .cmp-button.cmp-button-secondary, \n      .cmp-button.cmp-button-secondary:hover {\n        background-color: #fff;\n        color: ".concat(customColor, ";\n      }\n\n      .cmp-button, \n      .cmp-button:hover {\n        background-color: ").concat(customColor, ";\n        border-color: ").concat(customColor, ";\n      }\n    \n    ")
    });
};
var renderStageContainer = function(color, showPoweredBy) {
    return /*#__PURE__*/ _jsx(StageContentContainer, {
        isAffiliate: true,
        children: /*#__PURE__*/ _jsxs(StageCaption, {
            children: [
                setAffiliateConsentStyle(color),
                /*#__PURE__*/ _jsx(SearchForm, {
                    isAffiliate: true,
                    customColor: color,
                    showPoweredBy: showPoweredBy
                })
            ]
        })
    });
};
var AffiliateSearchForm = function(param) {
    var color = param.color, showPoweredBy = param.showPoweredBy;
    var formatImage = HostLegacy.useHost().formatImage;
    var image = {
        src: formatImage("/bm/global/files/images/XL-M_1400x470_200kb.jpg"),
        alt: "car-rental",
        id: "car-rental-stage"
    };
    if (showPoweredBy) {
        return renderStageContainer(color, showPoweredBy);
    }
    return /*#__PURE__*/ _jsx(LayoutLegacy.ImageSegment, {
        image: image,
        children: renderStageContainer(color, showPoweredBy)
    });
};
export { AffiliateSearchForm };
